export function IconUser() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24">
      <g fill="none" stroke="currentColor" strokeWidth={1.5}>
        <circle cx={12} cy={6} r={4}></circle>
        <path d="M20 17.5c0 2.485 0 4.5-8 4.5s-8-2.015-8-4.5S7.582 13 12 13s8 2.015 8 4.5Z"></path>
      </g>
    </svg>
  );
}

export function IconDocumentAdd() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24">
      <g fill="none" stroke="currentColor" strokeWidth={1.5}>
        <path d="m18.18 8.04l.463-.464a1.966 1.966 0 1 1 2.781 2.78l-.463.464M18.18 8.04s.058.984.927 1.853s1.854.927 1.854.927M18.18 8.04l-4.26 4.26c-.29.288-.434.433-.558.592q-.22.282-.374.606c-.087.182-.151.375-.28.762l-.413 1.24l-.134.401m8.8-5.081l-4.26 4.26c-.29.29-.434.434-.593.558q-.282.22-.606.374c-.182.087-.375.151-.762.28l-1.24.413l-.401.134m0 0l-.401.134a.53.53 0 0 1-.67-.67l.133-.402m.938.938l-.938-.938"></path>
        <path
          strokeLinecap="round"
          d="M8 13h2.5M8 9h6.5M8 17h1.5M3 14v-4c0-3.771 0-5.657 1.172-6.828S7.229 2 11 2h2c3.771 0 5.657 0 6.828 1.172M21 14c0 3.771 0 5.657-1.172 6.828m-15.656 0C5.343 22 7.229 22 11 22h2c3.771 0 5.657 0 6.828-1.172m0 0c.944-.943 1.127-2.348 1.163-4.828"
        ></path>
      </g>
    </svg>
  );
}

export function IconBank() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24">
      <path
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.5}
        d="M2 8.57c0-1.197.482-1.93 1.48-2.486l4.11-2.287C9.743 2.6 10.82 2 12 2s2.257.6 4.41 1.797l4.11 2.287C21.517 6.64 22 7.373 22 8.57c0 .324 0 .487-.035.62c-.186.7-.821.811-1.434.811H3.469c-.613 0-1.247-.11-1.434-.811C2 9.056 2 8.893 2 8.569M11.996 7h.009M4 10v8.5M8 10v8.5m8-8.5v8.5m4-8.5v8.5m-1 0H5a3 3 0 0 0-3 3a.5.5 0 0 0 .5.5h19a.5.5 0 0 0 .5-.5a3 3 0 0 0-3-3"
        color="currentColor"
      ></path>
    </svg>
  );
}

export function IconPlan() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24">
      <path
        fill="currentColor"
        d="M3.25 5A2.75 2.75 0 0 1 6 2.25h10A2.75 2.75 0 0 1 18.75 5v5.5a.75.75 0 0 1-1.5 0V5c0-.69-.56-1.25-1.25-1.25H6c-.69 0-1.25.56-1.25 1.25v14c0 .69.56 1.25 1.25 1.25h7.5a.75.75 0 0 1 0 1.5H6A2.75 2.75 0 0 1 3.25 19z"
      ></path>
      <path
        fill="currentColor"
        d="M18 13.25a.75.75 0 0 1 .75.75v.418c1.027.038 2 .795 2 1.915a.75.75 0 0 1-1.5 0c0-.142-.162-.416-.581-.416h-1.506a.5.5 0 0 0-.329.112c-.068.06-.084.117-.084.154a.5.5 0 0 0 .018.149a.3.3 0 0 0 .042.026c.04.02.1.044.193.072l2.418.701c.276.082.63.218.908.513c.3.32.421.73.421 1.173c0 1.067-.956 1.766-1.913 1.766h-.087V21a.75.75 0 0 1-1.5 0v-.418c-1.027-.038-2-.795-2-1.915a.75.75 0 0 1 1.5 0c0 .142.162.416.581.416h1.506a.5.5 0 0 0 .329-.112c.068-.06.084-.117.084-.154a.5.5 0 0 0-.018-.149a.3.3 0 0 0-.042-.026c-.04-.02-.1-.044-.193-.072l-2.418-.701c-.276-.082-.63-.218-.908-.513c-.3-.32-.421-.73-.421-1.173c0-1.067.956-1.766 1.913-1.766h.087V14a.75.75 0 0 1 .75-.75M6.25 11a.75.75 0 0 1 .75-.75h.5a.75.75 0 0 1 0 1.5H7a.75.75 0 0 1-.75-.75m3 0a.75.75 0 0 1 .75-.75h5a.75.75 0 0 1 0 1.5h-5a.75.75 0 0 1-.75-.75m-3 3a.75.75 0 0 1 .75-.75h.5a.75.75 0 0 1 0 1.5H7a.75.75 0 0 1-.75-.75m3 0a.75.75 0 0 1 .75-.75h3.5a.75.75 0 0 1 0 1.5H10a.75.75 0 0 1-.75-.75m-3 3a.75.75 0 0 1 .75-.75h.5a.75.75 0 0 1 0 1.5H7a.75.75 0 0 1-.75-.75m3 0a.75.75 0 0 1 .75-.75h2a.75.75 0 0 1 0 1.5h-2a.75.75 0 0 1-.75-.75M6 6.5c0-.466 0-.699.076-.883a1 1 0 0 1 .541-.54C6.801 5 7.034 5 7.5 5h7c.466 0 .699 0 .883.076a1 1 0 0 1 .54.541c.077.184.077.417.077.883s0 .699-.076.883a1 1 0 0 1-.541.54C15.199 8 14.966 8 14.5 8h-7c-.466 0-.699 0-.883-.076a1 1 0 0 1-.54-.541C6 7.199 6 6.966 6 6.5"
      ></path>
    </svg>
  );
}

export function IconDollar() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24">
      <g fill="none" stroke="currentColor" strokeLinecap="round" strokeWidth={1.5}>
        <path d="M12 6v12m3-8.5C15 8.12 13.657 7 12 7S9 8.12 9 9.5s1.343 2.5 3 2.5s3 1.12 3 2.5s-1.343 2.5-3 2.5s-3-1.12-3-2.5"></path>
        <path d="M7 3.338A9.95 9.95 0 0 1 12 2c5.523 0 10 4.477 10 10s-4.477 10-10 10S2 17.523 2 12c0-1.821.487-3.53 1.338-5"></path>
      </g>
    </svg>
  );
}

export function IconPdf() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 32 32">
      <path fill="#909090" d="m24.1 2.072l5.564 5.8v22.056H8.879V30h20.856V7.945z"></path>
      <path fill="#f4f4f4" d="M24.031 2H8.808v27.928h20.856V7.873z"></path>
      <path fill="#7a7b7c" d="M8.655 3.5h-6.39v6.827h20.1V3.5z"></path>
      <path fill="#dd2025" d="M22.472 10.211H2.395V3.379h20.077z"></path>
      <path
        fill="#464648"
        d="M9.052 4.534H7.745v4.8h1.028V7.715L9 7.728a2 2 0 0 0 .647-.117a1.4 1.4 0 0 0 .493-.291a1.2 1.2 0 0 0 .335-.454a2.1 2.1 0 0 0 .105-.908a2.2 2.2 0 0 0-.114-.644a1.17 1.17 0 0 0-.687-.65a2 2 0 0 0-.409-.104a2 2 0 0 0-.319-.026m-.189 2.294h-.089v-1.48h.193a.57.57 0 0 1 .459.181a.92.92 0 0 1 .183.558c0 .246 0 .469-.222.626a.94.94 0 0 1-.524.114m3.671-2.306c-.111 0-.219.008-.295.011L12 4.538h-.78v4.8h.918a2.7 2.7 0 0 0 1.028-.175a1.7 1.7 0 0 0 .68-.491a1.9 1.9 0 0 0 .373-.749a3.7 3.7 0 0 0 .114-.949a4.4 4.4 0 0 0-.087-1.127a1.8 1.8 0 0 0-.4-.733a1.6 1.6 0 0 0-.535-.4a2.4 2.4 0 0 0-.549-.178a1.3 1.3 0 0 0-.228-.017m-.182 3.937h-.1V5.392h.013a1.06 1.06 0 0 1 .6.107a1.2 1.2 0 0 1 .324.4a1.3 1.3 0 0 1 .142.526c.009.22 0 .4 0 .549a3 3 0 0 1-.033.513a1.8 1.8 0 0 1-.169.5a1.1 1.1 0 0 1-.363.36a.67.67 0 0 1-.416.106m5.08-3.915H15v4.8h1.028V7.434h1.3v-.892h-1.3V5.43h1.4v-.892"
      ></path>
      <path
        fill="#dd2025"
        d="M21.781 20.255s3.188-.578 3.188.511s-1.975.646-3.188-.511m-2.357.083a7.5 7.5 0 0 0-1.473.489l.4-.9c.4-.9.815-2.127.815-2.127a14 14 0 0 0 1.658 2.252a13 13 0 0 0-1.4.288Zm-1.262-6.5c0-.949.307-1.208.546-1.208s.508.115.517.939a10.8 10.8 0 0 1-.517 2.434a4.4 4.4 0 0 1-.547-2.162Zm-4.649 10.516c-.978-.585 2.051-2.386 2.6-2.444c-.003.001-1.576 3.056-2.6 2.444M25.9 20.895c-.01-.1-.1-1.207-2.07-1.16a14 14 0 0 0-2.453.173a12.5 12.5 0 0 1-2.012-2.655a11.8 11.8 0 0 0 .623-3.1c-.029-1.2-.316-1.888-1.236-1.878s-1.054.815-.933 2.013a9.3 9.3 0 0 0 .665 2.338s-.425 1.323-.987 2.639s-.946 2.006-.946 2.006a9.6 9.6 0 0 0-2.725 1.4c-.824.767-1.159 1.356-.725 1.945c.374.508 1.683.623 2.853-.91a23 23 0 0 0 1.7-2.492s1.784-.489 2.339-.623s1.226-.24 1.226-.24s1.629 1.639 3.2 1.581s1.495-.939 1.485-1.035"
      ></path>
      <path fill="#909090" d="M23.954 2.077V7.95h5.633z"></path>
      <path fill="#f4f4f4" d="M24.031 2v5.873h5.633z"></path>
      <path
        fill="#fff"
        d="M8.975 4.457H7.668v4.8H8.7V7.639l.228.013a2 2 0 0 0 .647-.117a1.4 1.4 0 0 0 .493-.291a1.2 1.2 0 0 0 .332-.454a2.1 2.1 0 0 0 .105-.908a2.2 2.2 0 0 0-.114-.644a1.17 1.17 0 0 0-.687-.65a2 2 0 0 0-.411-.105a2 2 0 0 0-.319-.026m-.189 2.294h-.089v-1.48h.194a.57.57 0 0 1 .459.181a.92.92 0 0 1 .183.558c0 .246 0 .469-.222.626a.94.94 0 0 1-.524.114m3.67-2.306c-.111 0-.219.008-.295.011l-.235.006h-.78v4.8h.918a2.7 2.7 0 0 0 1.028-.175a1.7 1.7 0 0 0 .68-.491a1.9 1.9 0 0 0 .373-.749a3.7 3.7 0 0 0 .114-.949a4.4 4.4 0 0 0-.087-1.127a1.8 1.8 0 0 0-.4-.733a1.6 1.6 0 0 0-.535-.4a2.4 2.4 0 0 0-.549-.178a1.3 1.3 0 0 0-.228-.017m-.182 3.937h-.1V5.315h.013a1.06 1.06 0 0 1 .6.107a1.2 1.2 0 0 1 .324.4a1.3 1.3 0 0 1 .142.526c.009.22 0 .4 0 .549a3 3 0 0 1-.033.513a1.8 1.8 0 0 1-.169.5a1.1 1.1 0 0 1-.363.36a.67.67 0 0 1-.416.106m5.077-3.915h-2.43v4.8h1.028V7.357h1.3v-.892h-1.3V5.353h1.4v-.892"
      ></path>
    </svg>
  );
}

export function IconDocx() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 32 32">
      <defs>
        <linearGradient
          id="vscodeIconsFileTypeWord0"
          x1={4.494}
          x2={13.832}
          y1={-1712.086}
          y2={-1695.914}
          gradientTransform="translate(0 1720)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0} stopColor="#2368c4"></stop>
          <stop offset={0.5} stopColor="#1a5dbe"></stop>
          <stop offset={1} stopColor="#1146ac"></stop>
        </linearGradient>
      </defs>
      <path
        fill="#41a5ee"
        d="M28.806 3H9.705a1.19 1.19 0 0 0-1.193 1.191V9.5l11.069 3.25L30 9.5V4.191A1.19 1.19 0 0 0 28.806 3"
      ></path>
      <path fill="#2b7cd3" d="M30 9.5H8.512V16l11.069 1.95L30 16Z"></path>
      <path fill="#185abd" d="M8.512 16v6.5l10.418 1.3L30 22.5V16Z"></path>
      <path
        fill="#103f91"
        d="M9.705 29h19.1A1.19 1.19 0 0 0 30 27.809V22.5H8.512v5.309A1.19 1.19 0 0 0 9.705 29"
      ></path>
      <path
        d="M16.434 8.2H8.512v16.25h7.922a1.2 1.2 0 0 0 1.194-1.191V9.391A1.2 1.2 0 0 0 16.434 8.2"
        opacity={0.1}
      ></path>
      <path
        d="M15.783 8.85H8.512V25.1h7.271a1.2 1.2 0 0 0 1.194-1.191V10.041a1.2 1.2 0 0 0-1.194-1.191"
        opacity={0.2}
      ></path>
      <path
        d="M15.783 8.85H8.512V23.8h7.271a1.2 1.2 0 0 0 1.194-1.191V10.041a1.2 1.2 0 0 0-1.194-1.191"
        opacity={0.2}
      ></path>
      <path
        d="M15.132 8.85h-6.62V23.8h6.62a1.2 1.2 0 0 0 1.194-1.191V10.041a1.2 1.2 0 0 0-1.194-1.191"
        opacity={0.2}
      ></path>
      <path
        fill="url(#vscodeIconsFileTypeWord0)"
        d="M3.194 8.85h11.938a1.193 1.193 0 0 1 1.194 1.191v11.918a1.193 1.193 0 0 1-1.194 1.191H3.194A1.19 1.19 0 0 1 2 21.959V10.041A1.19 1.19 0 0 1 3.194 8.85"
      ></path>
      <path
        fill="#fff"
        d="M6.9 17.988q.035.276.046.481h.028q.015-.195.065-.47c.05-.275.062-.338.089-.465l1.255-5.407h1.624l1.3 5.326a8 8 0 0 1 .162 1h.022a8 8 0 0 1 .135-.975l1.039-5.358h1.477l-1.824 7.748h-1.727l-1.237-5.126q-.054-.222-.122-.578t-.084-.52h-.021q-.021.189-.084.561t-.1.552L7.78 19.871H6.024L4.19 12.127h1.5l1.131 5.418a5 5 0 0 1 .079.443"
      ></path>
    </svg>
  );
}

export function IconMoney() {
  return (
    <svg width="1em" height="1em" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_265_738)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M17.25 21.7939C20.985 21.7939 24 20.2939 24 18.0439V3.79395C24 2.29395 21 0.793945 17.25 0.793945C13.5 0.793945 10.5 2.29395 10.5 3.79395V9.04395C12.255 9.77894 13.755 11.0089 14.82 12.5689C15.555 12.7129 16.365 12.7924 17.25 12.7924C19.215 12.7924 20.85 12.4009 22.02 11.7634C22.1861 11.6722 22.3478 11.573 22.5045 11.4664V13.5364C22.5045 13.8889 22.224 14.4364 21.3015 14.9404C20.4075 15.4279 19.0365 15.7864 17.2515 15.7864C16.8945 15.7864 16.5545 15.7729 16.2315 15.7459C16.3515 16.2409 16.4315 16.7459 16.4715 17.2609C16.7245 17.2749 16.9845 17.2819 17.2515 17.2819C19.2165 17.2819 20.8515 16.8904 22.0215 16.2529C22.1876 16.1617 22.3493 16.0625 22.506 15.9559V18.0259C22.506 18.3799 22.2825 18.9049 21.3195 19.4239C20.3715 19.9339 18.9495 20.2759 17.2545 20.2759C16.9095 20.2759 16.5755 20.2619 16.2525 20.2339C16.1372 20.7325 15.9822 21.2211 15.789 21.6949C16.261 21.7479 16.749 21.7744 17.253 21.7744L17.25 21.7939ZM21.3 10.4539C22.2225 9.94995 22.503 9.40245 22.503 9.04995V6.97995C22.348 7.08595 22.1865 7.18495 22.0185 7.27695C20.8515 7.91445 19.2135 8.30595 17.2485 8.30595C15.2835 8.30595 13.6485 7.91445 12.4785 7.27695C12.3124 7.18565 12.1507 7.08654 11.994 6.97995V9.04995C11.994 9.40245 12.2745 9.94995 13.197 10.4524C14.091 10.9399 15.462 11.2984 17.247 11.2984C19.032 11.2984 20.397 10.9399 21.297 10.4524L21.3 10.4539ZM12 4.54395C12 4.11195 12.1875 3.69645 12.537 3.44295C12.7275 3.30495 12.9345 3.16695 13.098 3.09195C13.5075 2.90295 15.558 2.29245 17.253 2.29245C18.948 2.29245 20.418 2.63295 21.408 3.09195C21.594 3.17745 21.7995 3.31095 21.981 3.44295C22.3275 3.69345 22.506 4.10595 22.506 4.53345V4.54245C22.506 4.89495 22.2255 5.44245 21.303 5.94645C20.409 6.43395 19.038 6.79245 17.253 6.79245C15.468 6.79245 14.103 6.43245 13.203 5.94645C12.2805 5.44395 12 4.89495 12 4.54395Z"
          fill="#7E22CE"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M13.5 18.0439C13.5 21.7789 10.485 24.7939 6.75 24.7939C3.015 24.7939 0 21.7789 0 18.0439C0 14.3089 3.015 11.2939 6.75 11.2939C10.485 11.2939 13.5 14.3089 13.5 18.0439ZM12 18.0439C12 20.9389 9.645 23.2939 6.75 23.2939C3.855 23.2939 1.5 20.9389 1.5 18.0439C1.5 15.1489 3.855 12.7939 6.75 12.7939C9.645 12.7939 12 15.1489 12 18.0439Z"
          fill="#7E22CE"
        />
      </g>
      <defs>
        <clipPath id="clip0_265_738">
          <rect width="24" height="24" fill="white" transform="translate(0 0.793945)" />
        </clipPath>
      </defs>
    </svg>
  );
}

// export function IconBank() {
//   return (
//     <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
//       <path
//         d="M11.996 7.79395H12.005M4 10.7939V19.2939M8 10.7939V19.2939M16 10.7939V19.2939M20 10.7939V19.2939M2 9.36395C2 8.16694 2.482 7.43395 3.48 6.87795L7.59 4.59095C9.743 3.39395 10.82 2.79395 12 2.79395C13.18 2.79395 14.257 3.39395 16.41 4.59095L20.52 6.87795C21.517 7.43395 22 8.16694 22 9.36395C22 9.68795 22 9.85094 21.965 9.98394C21.779 10.6839 21.144 10.7949 20.531 10.7949H3.469C2.856 10.7949 2.222 10.6849 2.035 9.98394C2 9.84994 2 9.68795 2 9.36395ZM19 19.2939H5C4.20435 19.2939 3.44129 19.61 2.87868 20.1726C2.31607 20.7352 2 21.4983 2 22.2939C2 22.4266 2.05268 22.5537 2.14645 22.6475C2.24021 22.7413 2.36739 22.7939 2.5 22.7939H21.5C21.6326 22.7939 21.7598 22.7413 21.8536 22.6475C21.9473 22.5537 22 22.4266 22 22.2939C22 21.4983 21.6839 20.7352 21.1213 20.1726C20.5587 19.61 19.7956 19.2939 19 19.2939Z"
//         stroke="#0E7490"
//         stroke-width="1.5"
//         stroke-linecap="round"
//         stroke-linejoin="round"
//       />
//     </svg>
//   );
// }
